var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2 py-12 text-sm font-medium leading-5 text-gray-700"},[_vm._v(" Logging in to Featurebase, please wait... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }